import React from 'react';
import PropTypes from 'prop-types';

import {
    RIQPopover
} from './RIQPopover.jsx';
import Label from './Label.jsx';

export function Summary({className = null, description = null, insight = null, title, value}) {

    return (
        <article className={className}>
            <header>
                <Label
                    description={description}
                    title={title}
                />
            </header>
            <div>{value}</div>
            <footer>{insight}</footer>
        </article>
    );
}

Summary.propTypes = {
    className: PropTypes.string,
    description: PropTypes.node,
    insight: PropTypes.node,
    title: PropTypes.node.isRequired,
    value: PropTypes.node.isRequired
};

export function NumericalValue({className = null, formatted, value}) {
    const node = <div className={`tlw-text-xl tlw-font-bold tlw-leading-36 tlw-text-gray-900 ${className}`}>{formatted}</div>;

    return (
        <RIQPopover triggerNode={node}>
            <div className='tlw-px-7 tlw-py-4.5 tlw-leading-base tlw-text-gray-900'>
                {value}
            </div>
        </RIQPopover>
    );
}

NumericalValue.propTypes = {
    className: PropTypes.string,
    formatted: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
};

export function TextInsight({title, value}) {
    return (
        <div className='tlw-mt-1.5 tlw-text-sm tlw-text-gray-700'>
            {title}: {value}
        </div>
    );
}

TextInsight.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export function DeltaRelativeInsight({formatted, value}) {
    const isNegative = (value < 0);
    const isPositive = (value > 0);

    let colorClassName = 'tlw-text-gray-700';
    let rotation = 270;
    if (isNegative) {
        colorClassName = 'tlw-text-red-400';
        rotation = 90;
    } else if (isPositive) {
        colorClassName = 'tlw-text-green-400';
        rotation = 270;
    }

    return (
        <div className={`tlw-mt-1.5 ${colorClassName}`}>
            <span
                className='fa fa-play tlw-mr-2'
                style={{
                    transform: `rotate(${rotation}deg)`
                }}></span>
            {formatted}
        </div>
    );
}

DeltaRelativeInsight.propTypes = {
    formatted: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
};
